// extracted by mini-css-extract-plugin
export default {"content":"yi380DYJ","_premium":"QLQ7ltlL","expert":"nuCg16lt","mobile":"mobile","title":"JkGkeyXX","_capitalizeFirstLetter":"Og8n4JOK","subtitle":"M_9dbCmP"};